import { computed } from 'vue'

import type { ComputedRef, Ref } from 'vue'
import type { SelectionAdapter } from '../../app-select'

interface CreateMultiSelectionAdapterOptions<TValue = string | number> {
  modelValue: Ref<TValue[] | undefined>
  selectedValues: ComputedRef<TValue[]>
}

/**
 * Multi-select `SelectionAdapter`: toggles a value in the array on pick, keeps
 * the panel open, never highlights an option on open. Shared by
 * `useAppMultiSelect` and `useAppMultiSelectSearchable`.
 */
export const createMultiSelectionAdapter = <TValue = string | number>(
  options: CreateMultiSelectionAdapterOptions<TValue>,
): SelectionAdapter<TValue> => {
  const { modelValue, selectedValues } = options

  return {
    isSelected: o => selectedValues.value.includes(o.value),
    initialHighlightIndex: computed(() => -1),
    highlightFirstOnOpen: false,
    shouldCloseAfterSelect: false,
    toggleSelection: (o) => {
      const arr = selectedValues.value
      const i = arr.indexOf(o.value)
      modelValue.value = i >= 0
        ? arr.filter(v => v !== o.value)
        : [...arr, o.value]
    },
    hasValue: computed(() => selectedValues.value.length > 0),
    clearValue: () => { modelValue.value = [] },
  }
}
